export default "__VITE_PUBLIC_ASSET__b3af0f1c__"